import * as React from 'react';
import { Container, Grid, GridColumn, Image, Logo, Separator, Text } from 'telia-front-react';
import ErrorUtil from './ErrorUtil';

class PageErrorBoundary extends React.Component<any> {
  phoneIcon =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHGSURBVHgB7ZmNbcIwEIU/dQI26I3ACB6BDZoRugHZgG7ACGWD0AkYATZAnaCNFRCXBOc/sSPySScZ53Dei2znDLCwsPBSSBrfaZzT2N8+zwYhE/6n4sxMTAhl8bMxIeTF27Z50icEiOAWWnUtGBKqBQoBm4jIz/W1I08I1IQWFdfkCoGZMLQXI7QzPQhvjv6Nah/TuFCPzTmoz+94RC9e0/A7W/JrJsIjVx5CVg3yi+JjPKPF1BGceEtTA0KA4i1Np9CnytvjAdcudFFt1wvMos394gGXgR/V3uDmqNofBFRGGB5Tw04n1zSy/UG9gTUnHsJ2FXlCoCYi8juMqcgVAjWRkJ9KUpFrr3UxYch2sJgRTAvtRLXN3zLB8VQYx0RR/KxMFMV/McEaEvqbiMmvK11+tB2/E0I/E8WIe47fCWEYE/FA43dCOtzEliQxWQFYlysEaqLP+AkjIIxrwhTGHgVhHBNSGPfAiAjDmhAmWANNbrruMI4hfyKcRPwdobxlbmkmwJ4tdkxQVtQhPP8jZE/2dPXhaHXrs8KvBCD+jlAuGdpEgkfxmojqUqIYJzz/oufCkFWc9snqqWLbp9s1w8LCwuvxDxigRK0dqeoLAAAAAElFTkSuQmCC';

  public state = {
    hasError: false,
    otelReference: '',
  };

  public componentDidCatch(error: Error | null) {
    const otelReference = ErrorUtil.pushError(true, error);
    this.setState({ hasError: true, otelReference });
  }

  private readonly logoSeparator = (
    <>
      <Separator spacing="small" color="invisible" className={'hidden-lg hidden-xl'} />
      <Separator spacing="large" color="invisible" className={'hidden-xs hidden-sm hidden-md'} />
    </>
  );

  public render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Container>
        {this.logoSeparator}
        <Logo text={'Telia'} size={'small'} />
        {this.logoSeparator}
        <Grid align={['center-lg']} gutter={'none'} reverse={['lg']}>
          <GridColumn width={['min-xs', 'lg-6']}>
            <Image
              className="hidden-lg hidden-xl"
              align="left"
              role="presentation"
              width={144}
              srcset={'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_288/icons/Help_Center.svg'}
              sources={[
                {
                  srcset: 'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_576/icons/Help_Center.svg',
                  minWidth: '144px',
                },
              ]}
            />
            <Image
              className="hidden-md hidden-xs hidden-sm"
              align="center"
              role="presentation"
              width={288}
              srcset={'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_576/icons/Help_Center.svg'}
              sources={[
                {
                  srcset: 'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1152/icons/Help_Center.svg',
                  minWidth: '288px',
                },
              ]}
            />
            <Separator spacing="xsmall" color="invisible" className={'hidden-lg hidden-xl'} />
          </GridColumn>
          <GridColumn width={['lg-6']}>
            <Text>
              <h1>Vabandame, tekkis tehniline viga</h1>
              <h4 className={'text-break'}>
                <strong>{this.state.otelReference}</strong>
              </h4>
              <h4>Seni saad meiega ühendust klienditeeninduse numbril.</h4>
              <h4 className={'text__margin-half'}>
                <img width="24" height="24" alt="Phone" style={{ verticalAlign: 'text-bottom' }} src={this.phoneIcon} /> Eraklient &ndash; 123
              </h4>
              <h4 className={'text__margin-half'}>
                <img width="24" height="24" alt="Phone" style={{ verticalAlign: 'text-bottom' }} src={this.phoneIcon} /> Äriklient &ndash; 1551
              </h4>
            </Text>
          </GridColumn>
        </Grid>
        <Separator spacing="small" color="invisible" className={'hidden-xs hidden-sm hidden-md'} />
        <Separator spacing="medium" className={'hidden-lg hidden-xl'} />
        <Grid align={['center-md']} gutter={'none'} horizontalGutter={'medium'}>
          <GridColumn width={['lg-6']}>
            <Text>
              <h4>
                <strong>Нужно немного подождать!</strong>
              </h4>
              <h5>Мы проводим техническое обслуживание сайта, но скоро все снова заработает как надо.</h5>
              <h5>До этого с нами можно связаться по номерам службы поддержки 123 (частный клиент) или 1551 (бизнес-клиент).</h5>
              <h5>Спасибо за терпение!</h5>
            </Text>
            <Separator spacing="medium" className={'hidden-lg hidden-xl'} />
          </GridColumn>
          <GridColumn width={['lg-6']} border={['left-lg']}>
            <Text>
              <h4>
                <strong>You have to wait a bit.</strong>
              </h4>
              <h5>We are doing maintenance work on the website, but soon everything will be working like clockwork again.</h5>
              <h5>In the meantime, you can contact us by calling 123 (private customers) or 1551 (business customers).</h5>
              <h5>Thank you for your patience!</h5>
            </Text>
          </GridColumn>
        </Grid>
      </Container>
    );
  }
}

export default PageErrorBoundary;
